<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('report.modify_related') }}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :action="$t('report.modify_related')" :name="$t('dictionary.extdb')" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item v-if="selectProps.list" :label="$t('report.parent_resource')">
          <list-select
            v-model="form.parent_id"
            :listProps="selectProps"
            :formatter="row => this.selectFormatter(row)"
            :multiple="false"
            :dialog-params="{ mask: false, width: 900, title: $t('report.parent_resource') }" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import ListSelect from '@/sections/ListSelect'

export default {
  name: 'ExtResourceChangeRelatedDialog',
  components: {
    ListSelect,
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        parent_id: this.params.data[0].parent_id,
      },
      selectProps: {},
      selectFormatter: null,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  created () {
    this.initListSelectProps()
  },
  methods: {
    async initListSelectProps () {
      try {
        const { data } = await new this.$Manager('ext_resource_types', 'v1').get({
          id: this.params.data[0].parent_type_id,
        })
        const columns = []
        const filterOptions = {}
        const { attributes = [] } = data
        const targetAttrs = attributes.filter(item => item.name === this.params.data[0].parent_key)
        const filteredAttrs = attributes.filter(item => item.name !== this.params.data[0].parent_key)
        const attrs = [...targetAttrs, ...filteredAttrs]
        for (let i = 0; i < 4; i++) {
          if (attrs[i]) {
            const item = attrs[i]
            const col = {
              field: item.name,
              title: item.name,
              formatter: ({ row }) => {
                return row[item.name] || '-'
              },
            }
            columns.push(col)
            if (item.value_type === 0 && item.choices && item.choices.length) {
              filterOptions[item.name.toLowerCase()] = {
                label: item.name,
                filter: true,
                dropdown: true,
                items: item.choices.map(txt => {
                  return { label: txt, key: txt }
                }),
                formatter: (val) => {
                  return `custom_filter|${item.name}|equals|${val}`
                },
              }
            } else if (item.value_type === 0) {
              filterOptions[item.name.toLowerCase()] = {
                label: item.name,
                filter: true,
                formatter: (val) => {
                  return `custom_filter|${item.name}|contains|${val}`
                },
              }
            }
          }
        }

        this.selectProps = {
          list: this.$list.createList(this, {
            resource: 'ext_resources',
            apiVersion: 'v1',
            getParams: () => {
              return {
                scope: this.$store.getters.scope,
                ext_resource_type_id: this.params.data[0].parent_type_id,
              }
            },
            filterOptions,
          }),
          columns,
        }
        this.selectFormatter = (row) => {
          const { parent_key, parent_type } = this.params.data[0]
          if (parent_key && row[parent_key] && parent_type) {
            return `${row[parent_key]} (${parent_type} ${parent_key})`
          }
          if (parent_key && row[parent_key]) {
            return `${row[parent_key]} ( ${parent_key})`
          }
          return row.id
        }
      } catch (err) {
        this.loading = false
        throw err
      }
    },
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('update', {
          id: this.params.data[0].id,
          managerArgs: {
            data: { parent_id: this.form.parent_id || '' },
          },
        })
        this.cancelDialog()
        this.params.refresh()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
